import { Box, Paper, styled } from '@/shared/ui';

export const StyledNotifHeader = styled(Box)`
  display: flex;
  gap: 8px;
`;

export const StyledDate = styled('div')`
  margin-left: auto;
`;

export const StyledMessage = styled('div')`
  margin-left: 34px;
`;

export const StyledPaper = styled(Paper)<{
  isFirst: boolean;
  isLast: boolean;
  isUnread: boolean;
}>`
  border-top-left-radius: ${({ isFirst }) => (isFirst ? '16px' : '0')};
  border-top-right-radius: ${({ isFirst }) => (isFirst ? '16px' : '0')};
  border-bottom-left-radius: ${({ isLast }) => (isLast ? '16px' : '0')};
  border-bottom-right-radius: ${({ isLast }) => (isLast ? '16px' : '0')};
  background-color: ${({ isUnread, theme }) =>
    isUnread ? theme.palette.common.white : 'transparent'};
  display: flex;
  flex-direction: column;
  padding: 21px;
`;
